import { render } from "./resumesindex.vue?vue&type=template&id=494ced14&scoped=true"
import script from "./resumesindex.vue?vue&type=script&lang=js"
export * from "./resumesindex.vue?vue&type=script&lang=js"

import "./resumesindex.vue?vue&type=style&index=0&id=494ced14&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-494ced14"]])

export default __exports__